<template>
    <!--begin::Chat drawer-->
    <div id="kt_drawer_chat"
         class="bg-body drawer drawer-end drawer-on"
         data-kt-drawer="true"
         data-kt-drawer-name="chat"
         data-kt-drawer-overlay="true"
         data-kt-drawer-width="{default:'300px', 'md': '500px'}"
         data-kt-drawer-direction="end">
        <!--begin::Messenger-->
        <div class="card w-100" id="kt_drawer_chat_messenger">
            <!--begin::Card header-->
            <div class="card-header pe-5" id="kt_drawer_chat_messenger_header">
                <!--begin::Title-->
                <div class="card-title">
                    <!--begin::User-->
                    <div class="d-flex justify-content-center flex-column me-3">
                        <input type="text" v-model="filter.keyword" @keyup.enter="getListChatGroup(true)" class="form-control form-control-solid px-13" placeholder="Tìm kiếm..." />
                        <!--end::Info-->
                    </div>
                    <!--end::User-->
                </div>
                <!--end::Title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">
                    <!--begin::Menu-->
                    <!--end::Menu-->
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-active-icon-primary" @click="closeListChat()"
                         id="kt_drawer_chat_close">
                        <KTIcon icon-name="cross" icon-class="fs-2x" />
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body pt-5" id="kt_chat_contacts_body">
                <!--begin::List-->
                <div class="scroll-y me-n5 pe-5 h-200px h-lg-auto" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_header, #kt_app_header, #kt_toolbar, #kt_app_toolbar, #kt_footer, #kt_app_footer, #kt_chat_contacts_header" data-kt-scroll-wrappers="#kt_content, #kt_app_content, #kt_chat_contacts_body" data-kt-scroll-offset="5px">

                    <!--begin::User-->
                    <div class="d-flex flex-stack py-4" v-for="(item,index) in listChatGroup" :key="index" @click="openChat(item.id)">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-45px symbol-circle">
                                <common-avatar :src="item.avatar" :name="item.name" />
                                <div class="symbol-badge bg-success start-100 top-100 border-4 h-8px w-8px ms-n2 mt-n2" v-if="item.isOnline"></div>
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-5">
                                <a href="javascript:;" class="fs-5 fw-bold text-gray-900 text-hover-primary mb-2">{{item.name}}</a>
                                <div :class="{'fw-bold  ellipsis':true,'text-muted':item.lastMessageIsRead == true }" v-if="item.lastMessageType == 1">{{item.lastMessage}}</div>
                                <div :class="{'fw-bold  ellipsis':true,'text-muted':item.lastMessageIsRead == true }" v-else-if="item.lastMessageType == 2">Đã gửi File</div>
                                <div :class="{'fw-bold  ellipsis':true,'text-muted':item.lastMessageIsRead == true }" v-else-if="item.lastMessageType == 3">Đã gửi ảnh</div>
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">
                            <span class="text-muted fs-7 mb-1">{{formatDateTime(item.lastMessageDate)}}</span>
                        </div>
                        <!--end::Lat seen-->
                    </div>
                    <!--end::User-->
                    <!--begin::Separator-->
                    <div class="separator separator-dashed d-none"></div>

                    <!--end::User-->
                </div>
                <!--end::List-->
            </div>
            <!--end::Card body-->
            <!--begin::Card footer-->
            <!--end::Card footer-->
        </div>

        <!--end::Messenger-->
    </div>
    <!--end::Chat drawer-->
</template>

<script lang="ts">
    import { getAssetPath } from "@/core/helpers/assets";
    import { defineComponent, ref } from "vue";
    import { SignalRService } from "~/core/services/signalRService";
    import Dropdown4 from "@/components/dropdown/Dropdown4.vue";
    import type { ListChatGroupDto } from "~/core/services/ApiClient";
    const { showError, showInfo, showSuccess, showConfirm } = useMessageBox();
    import { onMounted, onUpdated } from 'vue';
    import { formatDate, formatDateTime, formatNumber } from "~/core/helpers/util";


    export default defineComponent({
        name: "upgrade-to-pro",
        components: {

        },
        setup(props, { emit }) {
            const messagesRef = ref<null | HTMLElement>(null);
            const messagesInRef = ref<null | HTMLElement>(null);
            const messagesOutRef = ref<null | HTMLElement>(null);
            const apiClient = useApiClient();
            const $loading = useLoading();
            const listChatGroup = ref<ListChatGroupDto[]>([]);
            const totalRows = ref(0);

            const filter = ref(<object>{
                pageSize: 100,
                pageIndex: 1,
                keyword: ""
            });

            const closeListChat = () => {
                emit("closeListChat");

            };;

            const getListChatGroup = (isSearch: boolean) => {

                apiClient
                    .listChatGroupOfUser(filter.value.keyword, filter.value.pageIndex, filter.value.pageSize)
                    .then((response) => {

                        listChatGroup.value = response.data?.data ?? [];
                        totalRows.value = response.data?.totalRows ?? 0;
                        if (route.query.chatGroupId)
                            startChat(parseInt(route.query.chatGroupId));
                        else if (listChatGroup.value.length > 0 && !isSearch)
                            startChat(listChatGroup.value[0].id);

                    })
                    .catch(() => {

                    });
            };

            const openChat = (chatGroupId: number) => {
                emit("openBoxChat", chatGroupId);
            };
            getListChatGroup(false);
            onMounted(() => {
                SignalRService.onReadMessage((data: object) => {
                    if (data != null) {
                        let chatGroup = listChatGroup.value.find((element) => element.id == data.chatGroupId);
                        if (chatGroup) {
                            chatGroup.lastMessageIsRead = true;
                        }
                    }
                });

            });
            return {
                getListChatGroup,
                listChatGroup,
                filter,
                totalRows,
                formatDateTime,
                openChat,
                closeListChat,
            };
        },
    });
</script>
